// client/src/routes/app/action-center.tsx — SCR-ACT-001 · ALR-004 (04 §8.12).
//
// Replaces UI-003's `PlaceholderScreen`, which named ALR-003 as this route's owner. ALR-003
// built the engine and the two endpoints behind it; the screen is this item's.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema, and
// §8.12 asks for exactly that — „filters (property, type, status — search params)". A filtered
// Action Center is therefore a link a landlord can send to their manager.
//
// NO PERMISSION GUARD: 04 §6.2 gates this entry on „(any)" and `GET /api/v1/task-items` is
// behind `Notifications.Read`, which every seeded role in this shell holds. The one gated thing
// is the STATUS MOVE (`Tasks.Manage`, withheld from the accountant — D-1036), and it is gated
// where it lives, on the row.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ActionCenter } from '@/features/notifications/ActionCenter';
import {
  actionCenterSearchSchema,
  type ActionCenterSearch,
} from '@/features/notifications/search';

export const Route = createFileRoute('/app/action-center')({
  validateSearch: actionCenterSearchSchema,
  component: ActionCenterScreen,
});

function ActionCenterScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <ActionCenter
      search={search}
      onSearchChange={(next: (previous: ActionCenterSearch) => ActionCenterSearch) => {
        void navigate({ search: next });
      }}
    />
  );
}
